export default "__VITE_ASSET__Bt2KTPTn__"